import React from 'react'
import {Link} from "react-router-dom";
import Sidebar from "../../../../../components/Sidebar";
import PageHeader from "../../../../../components/PageHeader";
import {toast} from "react-toastify";
import moment from "moment";
import DatePicker, {registerLocale} from "react-datepicker";
import vi from "date-fns/locale/vi";
import OfficerController from "../../../../../services/system/staff/officer-controller";
import {getSchoolAbbreviationName, getSchoolYear} from "../../../../../utils/authority";
import AddressManager from "../../../../../components/Address";
import PublicSecureAuthorization
    from "../../../../../services/system/secure-authorization/secure-authorization-controller";
import {withRouter} from "../../../../../utils/withRouter";
import DepartmentController from "../../../../../services/data-declaration/department-controller";
registerLocale("vi", vi);
class CreateStaff extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            departmentId: -1,
            address: "",
            provinceId: "",
            districtId: "",
            wardId: "",
            autoGenCode: true,
            birthday: new Date(),
            code: "",
            contract: "BIEN_CHE",
            degree: "DAI_HOC",
            email: "",
            ethnic: "KINH",
            fullName: "",
            gender: "MALE",
            identifyCard: "",
            provinceIdentifyCard: "",
            job: "",
            jobState: "WORKING",
            memberDay: new Date(),
            partyMemberDay: new Date(),
            dateIdentifyCard: new Date(),
            password: "123456@@",
            phone1: "",
            phone2: "",
            religion: "NO",
            schoolDay: new Date(),
            schoolId: -1,
            socialInsuranceNumber: "",
            status: "ACTIVE",
            username: "",
            group: "",
            listGroupUser: [],
            listDepartment: [],
            yearId: parseInt(getSchoolYear()),
            preUsername: getSchoolAbbreviationName(),
        };
    }
    componentDidMount() {
        this.getListGroupUser()
        this.getListDepartment()
    }
    renderDepartment = () => {
        return this.state.listDepartment.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    };
    getListGroupUser() {
        PublicSecureAuthorization.getListRoles(res => {
            if (res.success) {
                let data = res.data.content;
                this.setState(
                    {
                        listGroupUser: res.data.content
                    }
                );
            } else {
            }
        });
    }
    getListDepartment = () => {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            "sort": "created_at desc"
        };
        DepartmentController.getList(payload, res => {
            this.setState({
                showLoading: false,
                listDepartment: res.data.content,
                totalItem: res.data.totalElements,
                totalPage: Math.round(res.data.totalElements / this.state.pageSize)
            });
        })
    };
    onCreate = () => {
        let {fullName, username} = this.state;
        if (fullName == "" || fullName.length < 6){
            toast.error("Tên hiển thị phải lớn hơn 6 ký tự");
        }else {
            let payload = {
                "group": this.state.group,
                "addressUsually": this.state.address,
                "provinceCode": this.state.provinceId,
                "districtCode": this.state.districtId,
                "wardCode": this.state.wardId,
                "autoGenCode": this.state.autoGenCode,
                "departmentId": parseInt(this.state.departmentId),
                "birthday": this.state.birthday,
                "code": this.state.code,
                "contract": this.state.contract,
                "dateIdentifyCard": this.state.dateIdentifyCard,
                "degree": this.state.degree,
                "email": this.state.email,
                "ethnic": this.state.ethnic,
                "fullName": this.state.fullName,
                "gender": this.state.gender,
                "identifyCard": this.state.identifyCard,
                "job": this.state.job,
                "jobState": this.state.jobState,
                "memberDay": this.state.memberDay,
                "partyMemberDay": this.state.partyMemberDay,
                "password": this.state.password,
                "phone1": this.state.phone1,
                "phone2": "",
                "provinceIdentifyCard": this.state.provinceIdentifyCard,
                "religion": this.state.religion,
                "schoolDay": this.state.schoolDay,
                "socialInsuranceNumber": this.state.socialInsuranceNumber,
                "status": this.state.status,
                "username": this.state.username,
                "yearId": this.state.yearId
            }
            OfficerController.create(payload, res => {
                if (res.success){
                    toast.success("Tạo cán bộ thành công!")
                    setTimeout(() => {
                        this.props.navigate('/ad-sas-school/danh-sach-can-bo');
                    }, 200)
                } else {
                    toast.error("Đã xảy ra lỗi! " + res.message)
                }
            })
        }
    }
    render() {
        let {address, provinceId, districtId, wardId}  = this.state
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="list-staff" parentClass="staff-management"/>
                        <div className="mb-4 col-md-10 tab-content">
                            <div className="card col-12">
                                <div className='pt-3 mb-2'>
                                    <PageHeader routerEnable={true} title="Quản lý cán bộ"/>
                                    <div className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <h2 className='text-center mb-4'>THÊM MỚI CÁN BỘ</h2>
                                        <div className="row">
                                            <div className="col-12 d-flex mb-2">
                                                <div className="col-12 p-2 mb-2 bg-info bg-gradient text-white">Thông tin tài khoản</div>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Mã cán bộ(<span  style={{color: "red",}}>*</span>)</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    placeholder="Nhập mã cán bộ"
                                                    className="form-control shadow-none"
                                                    value={this.state.code}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            code: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) => {
                                                            const value = this.state.autoGenCode;
                                                            this.setState({autoGenCode: !value});
                                                        }}
                                                        checked={this.state.autoGenCode}
                                                    />
                                                    {' '}
                                                    Tự động sinh mã
                                                </label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tên đăng nhập(<span  style={{color: "red",}}>*</span>)</label>
                                                <label
                                                    className="pl-0 font-weight-bold kt-margin-b-10-tablet-and-mobile pt-1">
                                                    {this.state.preUsername}_
                                                </label>
                                                <input
                                                    maxLength={255}
                                                    type="text"
                                                    placeholder="Nhập tên đăng nhập"
                                                    className="form-control shadow-none"
                                                    value={this.state.username}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            username: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Mật khẩu(<span  style={{color: "red",}}>*</span>)</label>
                                                <input
                                                    maxLength={255}
                                                    type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.password}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            password: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Trạng thái tài khoản(<span  style={{color: "red",}}>*</span>)</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.status}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            status: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="ACTIVE">Hoạt động</option>
                                                    <option value="INACTIVE">Khóa</option>
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Nhóm người dùng(<span  style={{color: "red",}}>*</span>)</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.group}
                                                    onChange={(e) => {
                                                        this.state.group = e.target.value;
                                                        this.setState({
                                                            group: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="1">Tất cả</option>
                                                    {this.state.listGroupUser?.map((item, index) => <option value={item.role}>{item.role}</option>)}
                                                </select>
                                            </div>
                                            <div className="col-12 d-flex mb-2">
                                                <div className="col-12 p-2 mb-2 bg-info bg-gradient text-white">Thông tin cán bộ</div>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Họ và tên(<span  style={{color: "red",}}>*</span>)</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    placeholder="Nhập họ và tên cán bộ"
                                                    className="form-control shadow-none"
                                                    value={this.state.fullName}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            fullName: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tổ bộ môn</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.departmentId}
                                                    onChange={(e) => {
                                                        this.state.departmentId = e.target.value;
                                                        this.setState({
                                                            departmentId: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="">Lựa chọn</option>
                                                    {this.renderDepartment()}
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Email(<span  style={{color: "red",}}>*</span>)</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    placeholder="Nhập email cán bộ"
                                                    className="form-control shadow-none"
                                                    value={this.state.email}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            email: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Số điện thoại</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    placeholder="Nhập SĐT cán bộ"
                                                    className="form-control shadow-none"
                                                    value={this.state.phone1}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            phone1: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Ngày sinh</label>
                                                <DatePicker
                                                    locale="vi"
                                                    className="w-auto  form-control kt-input pd-4-input hei-input"
                                                    selected={this.state.birthday === '' ? null : new Date(this.state.birthday)}
                                                    maxDate={new Date()}
                                                    placeholderText="Ngày-Tháng-Năm"
                                                    dateFormat="dd-MM-yyyy"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    onChange={
                                                        (date) => {
                                                            let value = moment(date).format("YYYY-MM-DD").toString();
                                                            try {
                                                                this.setState({
                                                                    birthday: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD"),
                                                                    inEditing: true
                                                                })
                                                            }catch (e) {

                                                            }
                                                        }
                                                    }
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Giới tính(<span  style={{color: "red",}}>*</span>)</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.gender}
                                                    onChange={(e) => {
                                                        this.state.gender = e.target.value;
                                                        this.setState({
                                                            gender: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="">Giới tính</option>
                                                    <option value="MALE">Nam</option>
                                                    <option value="FEMALE">Nữ</option>
                                                    <option value="OTHER ">Khác</option>
                                                </select>
                                            </div>

                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Số CMND/CCCD</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    placeholder="Nhập CCCD/CMND"
                                                    className="form-control shadow-none"
                                                    value={this.state.identifyCard}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            identifyCard: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-3 d-flex mb-2">
                                                <DatePicker
                                                    locale="vi"
                                                    className="w-auto  form-control kt-input pd-4-input hei-input"
                                                    selected={this.state.dateIdentifyCard === '' ? null : new Date(this.state.dateIdentifyCard)}
                                                    minDate={new Date()}
                                                    placeholderText="Ngày-Tháng-Năm"
                                                    dateFormat="dd-MM-yyyy"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    onChange={
                                                        (date) => {
                                                            let value = moment(date).format("YYYY-MM-DD").toString();
                                                            try {
                                                                this.setState({
                                                                    dateIdentifyCard: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD"),
                                                                    inEditing: true
                                                                })
                                                            }catch (e) {

                                                            }
                                                        }
                                                    }
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-3 d-flex mb-2">
                                                <input
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    placeholder="Nơi cấp CCCD/CMND"
                                                    onChange={(event) => {
                                                        this.setState({
                                                            provinceIdentifyCard: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Dân tộc(<span  style={{color: "red",}}>*</span>)</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.ethnic}
                                                    onChange={(e) => {
                                                        this.state.ethnic = e.target.value;
                                                        this.setState({
                                                            ethnic: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="KINH">Kinh</option>
                                                    <option value="OTHER">Khác</option>
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tôn giáo(<span  style={{color: "red",}}>*</span>)</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.religion}
                                                    onChange={(e) => {
                                                        this.state.religion = e.target.value;
                                                        this.setState({
                                                            religion: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="NO">Không</option>
                                                    <option value="YES">Có</option>
                                                </select>
                                            </div>
                                            <div className="col-12 d-flex mb-2">
                                                <div className="col-12 p-2 mb-2 bg-info bg-gradient text-white">Quê quán</div>
                                            </div>
                                            <AddressManager
                                                addressUsually={address}
                                                districtId={districtId}
                                                provinceId={provinceId}
                                                wardId={wardId}
                                                onUpdateAddress={(address, wardId, districtId, provinceId) => this.setState({address: address, districtId: districtId, provinceId: provinceId, wardId: wardId})}
                                            />
                                            <div className="col-12 d-flex mb-2">
                                                <div className="col-12 p-2 mb-2 bg-info bg-gradient text-white">Hợp đồng</div>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Ngày vào trường</label>
                                                <DatePicker
                                                    locale="vi"
                                                    className="w-auto  form-control kt-input pd-4-input hei-input"
                                                    selected={this.state.schoolDay === '' ? null : new Date(this.state.schoolDay)}
                                                    minDate={new Date()}
                                                    placeholderText="Ngày-Tháng-Năm"
                                                    dateFormat="dd-MM-yyyy"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    onChange={
                                                        (date) => {
                                                            let value = moment(date).format("YYYY-MM-DD").toString();
                                                            try {
                                                                this.setState({
                                                                    schoolDay: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD"),
                                                                    inEditing: true
                                                                })
                                                            }catch (e) {

                                                            }
                                                        }
                                                    }
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Bằng cấp(<span  style={{color: "red",}}>*</span>)</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.degree}
                                                    onChange={(e) => {
                                                        this.state.degree = e.target.value;
                                                        this.setState({
                                                            degree: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="TRUNG_CAP">Trung cấp</option>
                                                    <option value="CAO_DANG">Cao đẳng</option>
                                                    <option value="DAI_HOC">Đại học</option>
                                                    <option value="THAC_SI">Thạc sĩ</option>
                                                    <option value="TIEN_SI">Tiến sĩ</option>
                                                    <option value="PGS_TIEN_SI">PGS.Tiến ĩ</option>
                                                    <option value="GIAO_SU">Giáo sư</option>
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Số sổ BHXH</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    placeholder="Nhập số sổ BHXH"
                                                    className="form-control shadow-none"
                                                    value={this.state.socialInsuranceNumber}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            socialInsuranceNumber: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Vị trí làm việc</label>
                                                <input
                                                    maxLength={255} type="text"
                                                    placeholder="Nhập vị trí làm việc hiện tại"
                                                    className="form-control shadow-none"
                                                    value={this.state.job}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            job: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Loại hợp đồng(<span  style={{color: "red",}}>*</span>)</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.contract}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            contract: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="BIEN_CHE">Biên chế</option>
                                                    <option value="HOP_DONG">Hợp đồng</option>
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Trạng thái công việc(<span  style={{color: "red",}}>*</span>)</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.jobState}
                                                    onChange={(e) => {
                                                        this.state.jobState = e.target.value;
                                                        this.setState({
                                                            jobState: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="WORKING">Đang làm việc</option>
                                                    <option value="STOP">Dừng làm việc</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="align-right col-12">
                                    <div className="d-flex justify-content-center align-center mt-3 mb-2">
                                        <button
                                            type="button"
                                            className="ml-4 border-1-s background-btn type-button-fix btn btn-primary shadow-none"
                                            disabled={this.state.fullName == "" || this.state.username == ""}
                                            onClick={()=> {
                                                this.onCreate()
                                            }}
                                        >
                                            Lưu
                                        </button>
                                        <button
                                            type="button"
                                            className="ml-4  border-1-s type-button-fix btn btn-light shadow-none"
                                        >
                                            <Link
                                                style={{color: '#000'}}
                                                to={{
                                                    pathname: "/ad-sas-school/danh-sach-can-bo"
                                                }}
                                            >
                                                Hủy bỏ
                                            </Link>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default withRouter(CreateStaff)
